import { render, staticRenderFns } from "./UserAnnotations.vue?vue&type=template&id=1aabf08f&scoped=true&"
import script from "./UserAnnotations.vue?vue&type=script&lang=js&"
export * from "./UserAnnotations.vue?vue&type=script&lang=js&"
import style0 from "./UserAnnotations.vue?vue&type=style&index=0&id=1aabf08f&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1aabf08f",
  null
  
)

export default component.exports